export default defineNuxtRouteMiddleware((to, from) => {
    const showMobileMenu = useMobileMenuOpen();

    // * if user go to a new route
    if (to !== from) {
        showMobileMenu.value = false;
    }
});
